import * as angular from 'angular';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { Ng1AppModule } from '../old-crazy-web-frontend/src/app';
import { setAngularJSGlobal } from '@angular/upgrade/static';

if (environment.production) {
  enableProdMode();
}

setAngularJSGlobal(angular);

Ng1AppModule.then(() => {
  platformBrowserDynamic().bootstrapModule(AppModule);
});
